import { defineNuxtPlugin, onNuxtReady, useRuntimeConfig } from 'nuxt/app'
import { createMatomoClient } from '@packages/matomo'
import { useAppStore } from '../stores/app'

export default defineNuxtPlugin({
  name: 'matomo',
  dependsOn: ['shared-app-store', 'app-request-context'],
  setup(nuxtApp) {
    const runtimeConfig = useRuntimeConfig()
    const publicRuntimeConfig = runtimeConfig.public as Record<string, unknown>
    const appStore = useAppStore(nuxtApp.$pinia)
    const matomo = createMatomoClient({
      host: () => window.location.host,
      matomoEnabled: publicRuntimeConfig.matomoEnabled !== false,
      matomoSiteId: typeof publicRuntimeConfig.matomoSiteId === 'string' ? publicRuntimeConfig.matomoSiteId : '',
      matomoTrackerUrl:
        typeof publicRuntimeConfig.matomoTrackerUrl === 'string' ? publicRuntimeConfig.matomoTrackerUrl : '',
      store: appStore,
    })

    matomo.init()

    nuxtApp.provide('matomo', matomo)
    nuxtApp.vueApp.config.globalProperties.matomofn = matomo.matomofn
    window.matomofn = matomo.matomofn

    onNuxtReady(() => {
      matomo.trackPageView()
    })

    nuxtApp.hook('page:finish', () => {
      matomo.trackPageView()
    })
  },
})
